// VAT helpers. Mirror lives at functions/pricing.js — keep in sync.
// UAE VAT is a flat 5%; no per-SP rate variation.

const n = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0);
const round2 = (v) => Math.round(n(v) * 100) / 100;

export const extractInclusiveVat = (gross) => round2(n(gross) - n(gross) / 1.05);
export const exclusiveVatOnTop = (net) => round2(n(net) * 0.05);

// Snapshotted onto the booking's `price` object at creation time so
// refunds / audits / VAT invoices use the SP config at booking time.
export const buildVatSnapshot = (sp, vatAmount) => ({
  vat: round2(vatAmount),
  vatRegistered: !!(sp && sp.vatRegistered),
  pricesIncludeVat: !!(sp && sp.pricesIncludeVat),
  spTrn: (sp && sp.trnNumber) || '',
  spLegalName: (sp && sp.legalName) || '',
});
